import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../store/auth.store';

interface GuestRouteProps {
  children: React.ReactNode;
}

export const GuestRoute: React.FC<GuestRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuthStore();
  const location = useLocation();

  if (isAuthenticated) {
    const params = new URLSearchParams(location.search);
    const next = params.get('next') || '/';
    const safePath = next.startsWith('/') && !next.startsWith('//') ? next : '/';

    return <Navigate to={safePath} replace />;
  }

  return <>{children}</>;
};

